(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koorui-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koorui-contact')) {
    customElements.define('koorui-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const select = this.querySelector('[data-contact-select]');
        if (!select) return;
        const cards = this.querySelectorAll('[data-contact-topic]');
        const fields = this.querySelectorAll('[data-contact-fields]');
        const sync = () => {
          const topic = select.selectedOptions[0].dataset.topic;
          cards.forEach(card => card.setAttribute('aria-pressed', String(card.dataset.contactTopic === topic)));
          fields.forEach(fieldset => {
            const inactive = fieldset.dataset.contactFields !== topic;
            fieldset.hidden = inactive;
            fieldset.disabled = inactive;
          });
        };
        cards.forEach(card => card.addEventListener('click', () => {
          const option = Array.from(select.options).find(item => item.dataset.topic === card.dataset.contactTopic);
          if (option) select.value = option.value;
          sync();
          const target = this.querySelector('.kc-contact__form-card');
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          select.focus({ preventScroll: true });
        }));
        select.addEventListener('change', sync);
        window.addEventListener('pageshow', sync);
        sync();
        const result = this.querySelector('[data-contact-result]');
        if (result) result.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koorui-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koorui-home-hero')) {
    customElements.define('koorui-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.stopAutoplay();
        this.visibilityObserver?.disconnect();
        this.controller = new AbortController();
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        const signal = this.controller.signal;
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.panels.length > 1;
        this.interval = Math.max(3, Math.min(10, Number(this.dataset.interval) || 5)) * 1000;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motionPreference.matches;
        this.hoverPaused = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
        this.focusPaused = this.contains(document.activeElement);
        this.editorSelected = false;
        this.inViewport = true;
        this.playButton = this.querySelector('[data-autoplay-toggle]');
        this.select(0);
        this.querySelectorAll('[data-step]').forEach(button => {
          button.addEventListener('click', () => {
            this.select(this.index + Number(button.dataset.step));
            this.scheduleAutoplay();
          }, { signal });
          button.addEventListener('keydown', event => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
            this.scheduleAutoplay();
          }, { signal });
        });
        this.playButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          if (!this.userPaused) this.focusPaused = false;
          this.updatePlaybackControl();
          this.scheduleAutoplay();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hoverPaused = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hoverPaused = false;
          this.scheduleAutoplay();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.contains(document.activeElement)) this.focusPaused = false;
            this.scheduleAutoplay();
          });
        }, { signal });
        document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), { signal });
        document.addEventListener('close', () => this.scheduleAutoplay(), { signal, capture: true });
        this.motionPreference.addEventListener('change', event => {
          this.userPaused = event.matches;
          this.updatePlaybackControl();
          this.scheduleAutoplay();
        }, { signal });
        this.visibilityObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.inViewport = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          this.scheduleAutoplay();
        }, { threshold: [0, 0.2] });
        this.visibilityObserver.observe(this);
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) {
            this.editorSelected = true;
            this.stopAutoplay();
            this.select(index);
          }
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelected = false;
          this.scheduleAutoplay();
        }, { signal });
        this.updatePlaybackControl();
        this.scheduleAutoplay();
      }
      disconnectedCallback() {
        this.stopAutoplay();
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
      }
      canAutoplay() {
        return this.isConnected && this.autoplayEnabled && !this.userPaused && !this.hoverPaused && !this.focusPaused && !this.editorSelected && this.inViewport && !document.hidden && !document.querySelector('dialog[open]');
      }
      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      scheduleAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;
        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = null;
          if (!this.canAutoplay()) return;
          this.select(this.index + 1);
          this.scheduleAutoplay();
        }, this.interval);
      }
      updatePlaybackControl() {
        if (!this.playButton) return;
        const label = this.userPaused ? this.playButton.dataset.labelPlay : this.playButton.dataset.labelPause;
        this.playButton.setAttribute('aria-label', label);
        this.playButton.title = label;
        this.playButton.querySelector('[data-icon-pause]').hidden = this.userPaused;
        this.playButton.querySelector('[data-icon-play]').hidden = !this.userPaused;
      }
      select(index) {
        if (!this.panels.length) return;
        this.index = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
        this.dataset.tone = this.panels[this.index].classList.contains('kh-hero__panel--light') ? 'light' : 'dark';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
